import React, { FC } from "react";
import {
  Container,
  ContainerTitle,
  ServicesWrapper,
  ServiceItem,
  IconService,
  TitleWrapper,
  ServiceTitle,
  ServiceSubTitle,
  SoonText,
} from "./styles";
import { useUi } from "../../../../context/ui.context";
import { useTranslation } from "react-i18next";
import NetworkIcon from './figma-network.svg'
import NetworkDarkIcon from './figma-network-dark.svg'
import ImagesIcon from './figma-image.svg'
import ImagesDarkIcon from './figma-image-dark.svg'
import RouterIcon from './figma-router.svg'
import RouterDarkIcon from './figma-router-dark.svg'
import SSHKeysIcon from './figma-ssh-key.svg'
import SSHKeysDarkIcon from './figma-ssh-key-dark.svg'
import BalancersIcon from './figma-load-balancer.svg'
import BalancersDarkIcon from './figma-load-balancer-dark.svg'
import FloatingIcon from './figma-floating-ip.svg'
import FloatingDarkIcon from './figma-floating-ip-dark.svg'
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/user.context";
type ItemProp = {
  item:any
}

const Services:FC = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const {user, quotas, appMenu} = useAuth()
  const {
    setViewModalComplete,
    setActiveAnimationComplete,
    viewAlert,
  } = useUi()
  const _createFuncImage = () => {
    if(!user.user.active_client){
      navigate('/complete-registration')
    } else if(user.requires_email_verification){
      setViewModalComplete(true)
      setActiveAnimationComplete(true)
    } else {
      navigate('/images/create')
    }
  }
  const _createFuncRouter = () => {
    if(!user.user.active_client){
      navigate('/complete-registration')
    } else if(user.requires_email_verification){
      setViewModalComplete(true)
      setActiveAnimationComplete(true)
    } else if(quotas?.network?.router?.limit === (quotas?.network?.router?.in_use ?? quotas?.network?.router?.used)){
      viewAlert({
        severity:'error',
        message:`${t('ROUTER_QUOTA_EXCEEDED')}`,
      })
    } else {
      // openModal('create-router')
      navigate('/routers')
    }
  }
  const _createFuncFloating = () => {
    if(!user.user.active_client){
      navigate('/complete-registration')
    } else if(user.requires_email_verification){
      setViewModalComplete(true)
      setActiveAnimationComplete(true)
    } else if(quotas?.network?.floatingip?.limit === (quotas?.network?.floatingip?.in_use ?? quotas?.network?.floatingip?.used)){
      viewAlert({
        severity:'error',
        message:`${t('FLOATING_IP_QUOTA_EXCEEDED')}`,
      })
    } else {
      navigate('/floating-ips/create')
    }
  }
  const _createFuncNetwork = () => {
    if(!user.user.active_client){
      navigate('/complete-registration')
    } else if(user.requires_email_verification){
      setViewModalComplete(true)
      setActiveAnimationComplete(true)
    } else if(quotas?.network?.network?.limit === (quotas?.network?.network?.in_use ?? quotas?.network?.network?.used)){
      viewAlert({
        severity:'error',
        message:`${t('NETWORK_QUOTA_EXCEEDED')}`,
      })
    } else {
      navigate('/networks/create')
    }
  }
  const createFuncNav = async (route:string) => {
    navigate(route)
  }
  const data = [
    {
      title:t("CREATE_NETWORK"),
      id:'1',
      content:t("CREATE_NETWORK_DESCRIPTION"),
      nav:() => _createFuncNetwork(),
      icon:NetworkIcon,
      dark:NetworkDarkIcon,
      slug:'openstack.networks',
    },
    {
      title:t("CREATE_IMAGE"),
      id:'2',
      content:t("CREATE_IMAGE_DESCRIPTION"),
      // navigate:'/images/create',
      nav:() => _createFuncImage(),
      icon:ImagesIcon,
      dark:ImagesDarkIcon,
      slug:'openstack.images',
    },
    {
      title:t("CREATE_ROUTER"),
      id:'3',
      content:t("CREATE_ROUTER_DESCRIPTION"),
      // navigate:'/routers',
      nav:() => _createFuncRouter(),
      icon:RouterIcon,
      dark:RouterDarkIcon,
      slug:'openstack.routers',
    },
    {
      title:t("IMPORT_SSH"),
      id:'4',
      content:t("IMPORT_SSH_DESCRIPTION"),
      // navigate:'/ssh-keys/create',
      nav:() => createFuncNav('/ssh-keys/create'),
      icon:SSHKeysIcon,
      dark:SSHKeysDarkIcon,
      slug:'openstack.sshkeys',
    },
    {
      title:t("SPIN_UP_A_LOAD_BALANCER"),
      id:'5',
      content:t("SPIN_UP_A_LOAD_BALANCER_DESCRIPTION"),
      // disabled:true,
      // navigate:'/load-balancers/create',
      nav:() => createFuncNav('/load-balancers/create'),
      icon:BalancersIcon,
      dark:BalancersDarkIcon,
      slug:'openstack.lbaas',
    },
    {
      title:t("CREATE_FLOATING_IP"),
      id:'6',
      content:t("CREATE_FLOATING_IP_DESCRIPTION"),
      // navigate:'/floating-ips/create',
      nav:() => _createFuncFloating(),
      icon:FloatingIcon,
      dark:FloatingDarkIcon,
      slug:'openstack.floatingips',
    },
  ]
  const visibleData = data.filter((item:any) => appMenu.includes(item.slug))

  if(visibleData.length === 0) return null

  return (
    <Container data-test-id='home-other-services'>
      <ContainerTitle>
        {t("OTHER_SERVICES")}
      </ContainerTitle>
      <ServicesWrapper>
        {visibleData.map((item:any) => (
          <ServiceItemView key={item.id} item={item}/>
        ))}
      </ServicesWrapper>
    </Container>
  )
}


export default Services

const ServiceItemView:FC<ItemProp> = ({item}) => {
  const {themeDark} = useUi()
  const [t] = useTranslation()
  return (
    <ServiceItem disabled={item?.disabled} onClick={item?.disabled ? null : item?.nav} key={item.id}>
      <IconService src={themeDark ? item.dark : item.icon } />
      <TitleWrapper>
        <ServiceTitle>
          <>
            {item.title}
          </>
          {item?.disabled ? <SoonText>{t("SOON")}</SoonText> : ''}
        </ServiceTitle>
        <ServiceSubTitle>
          {item.content}
        </ServiceSubTitle>
      </TitleWrapper>
    </ServiceItem>
  )
}
